import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { LearnerFormResponse, LearnerFormUpdateRequest } from "@eduviaos/shared";
import { api } from "@/lib/api";

/** Phase SC-22 — a tenant's learner record form, as the super admin sees it. */
export const learnerFormKeys = {
  all: ["learner-form"] as const,
  tenant: (slug: string) => [...learnerFormKeys.all, slug] as const,
};

export function useTenantLearnerForm(tenantSlug: string) {
  return useQuery<LearnerFormResponse>({
    queryKey: learnerFormKeys.tenant(tenantSlug),
    queryFn: () => api.get<LearnerFormResponse>(`/super-admin/tenants/${tenantSlug}/learner-form`),
    enabled: Boolean(tenantSlug),
    staleTime: 30_000,
  });
}

export function useUpdateTenantLearnerForm(tenantSlug: string) {
  const qc = useQueryClient();
  return useMutation<LearnerFormResponse, Error, LearnerFormUpdateRequest>({
    mutationFn: (body) =>
      api.put<LearnerFormResponse>(`/super-admin/tenants/${tenantSlug}/learner-form`, body),
    onSuccess: (form) => {
      qc.setQueryData(learnerFormKeys.tenant(tenantSlug), form);
    },
  });
}
